import { render, staticRenderFns } from "./ItemProducts.vue?vue&type=template&id=01085593"
import script from "./ItemProducts.vue?vue&type=script&lang=js"
export * from "./ItemProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports